<template>
    <modal titulo="Auditorias" id="modal-auditorias">
      <card>
        <auditoria-pagination :referencia="referencia" :entidade="entidade" />
      </card>
    </modal>
</template>

<script>

import Modal from "@/components/Modal";
import Card from "@/components/Layout/components/Card.vue";
import AuditoriaPagination from "@/v2/components/Auditoria/AuditoriaPagination";

export default {
    name: "ModalAuditorias",
    components: {Card, Modal, AuditoriaPagination},
    props: {
        referencia : String,
        entidade : String
    },
    modal: {
      width: 1100
    },
    data() {
    return {
      teste: null
    }
  },

    methods: {}
  }
</script>

<style lang=scss>

</style>
